<template>
    <div class="calendarView">
        <div class="innerMainContent">
            <div class="innerHeader">
                <div class="h1Wrap">
                    <svg class="i_calender"><use xlink:href="#i_calender"></use></svg>
                    <div class="innerH1Wrap">
                        <h1>{{ $t('page_title_calendar') }}</h1>
                        <ul class="breadcrumb">
                            <li><a href="#">{{ $t('page_title_dashboard') }}</a></li>
                            <li class="active">{{ $t('page_title_calendar') }}</li>
                        </ul>
                    </div>
                </div>
                <div class="editEventActions">
                    <router-link tag="button" to="/events/add" class="addEvent">
                        <svg><use xlink:href="#i_plus"></use></svg>
                        <span>{{ $t('page_title_addEvent') }}</span>
                    </router-link>
                </div>
            </div>
            <div class="innerBox filterBox">
                <form @submit.prevent="">
                    <h3>
                        <svg><use xlink:href="#i_filter"></use></svg>
                        <span>{{ $t('filterEvents') }}</span>
                    </h3>
                    <div class="inputWrap">
                        <label for="halls">{{ $t('halls') }}</label>
                        <div class="selectWrap">
                            <select name="halls" id="halls" v-model="hall">
                                <option value="" selected="selected">{{ $t('select') }}</option>
                                <option v-for="hall of this.$store.state.halls" v-bind:value="hall.id">{{ hall.name }}</option>
                            </select>
                            <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                        </div>
                    </div>
                    <div class="inputWrap">
                        <label for="eventType">{{ $t('eventType') }}</label>
                        <div class="selectWrap">
                            <select name="eventType" id="eventType" v-model="eventType">
                                <option value="" selected="selected">{{ $t('select') }}</option>
                                <option v-for="eventType of this.$store.state.eventTypes" v-bind:value="eventType.id">{{ eventType.title }}</option>
                                <option value="holiday">{{ $t('eventType_holiday') }}</option>
                                <option value="meeting">{{ $t('eventType_meeting') }}</option>
                                <option value="quotation">{{ $t('eventType_quotation') }}</option>
                            </select>
                            <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                        </div>
                    </div>
                    <div class="orDivider">{{ $t('or') }}</div>
                    <div class="inputWrap searchWrapper">
                        <input type="search" v-bind:placeholder="$t('searchEvent') + '...'" v-model="input">
                        <button class="searchEvent">
                            <svg><use xlink:href="#i_search"></use></svg>
                            <span class="sr-only">{{ $t('searchEvent') }}</span>
                        </button>
                    </div>
                </form>

            </div>
            <div class="innerBox">
                <FullCalendar id='calendar' :events="getEvents()" :config="config"></FullCalendar>

            </div>
        </div>
    </div>
</template>

<script>
    import { FullCalendar } from 'vue-full-calendar'
    import moment from 'moment'
    export default {
        name: "Calendar",
        data(){
            return{
                config:this.getConfig(),
                hall:'',
                eventType:'',
                input:'',
                events:[]
            }
        },
        components:{
            FullCalendar
        },
        beforeMount(){
            this.$store.dispatch('getCalendar')
                                    .then(response =>{
                                        //success
                                        this.events = response;
                                        this.initiated = true;
                                    })
                                    .catch(err => {
                                        //err
                                        this.$swal({
                                            confirmButtonText:this.$t('okButton'),
                                            type:'error',
                                            title:this.$t('fatalError'),
                                            timer:3000
                                        }).catch(this.$swal.noop);
                                        this.$router.push('/');
                                    })
        },
        methods:{
            getConfig(){
                let _this = this;
                return {
                    customButtons: {
                        keysButton: {
                            text: _this.$t('mikra'),
                            click: function() {
                                $(this).parent().toggleClass("open");
                                if(!($('.keysButtonWrapper').length)){
                                    $(this).parent().append(_this.getEventTypes());
                                }
                            }
                        }
                    },
                    header: {
                        left: 'keysButton',
                        center: 'prev,title,next',
                        right: 'month,agendaWeek,agendaDay'
                    },
                    defaultView:'month',
                    buttonText:{month:_this.$t('month'),week:_this.$t('week'),day:_this.$t('day'),list:_this.$t('schedule')},
                    defaultDate: moment.now(),
                    navLinks: true, // can click day/week names to navigate views
                    selectable: true,
                    selectHelper: true,
                    isRTL:true,
                    locale:"he",
                    eventLimit: false, // for all non-agenda views
                    displayEventTime: false,
                    views: {
                        day: {
                            eventLimit: 4 // adjust to 6 only for agendaWeek/agendaDay
                        }
                    },
                    columnHeaderFormat:'dddd',
                    dayClick: function(start, end) {
                        _this.$router.push('/events/add/'+start.format("YYYY-MM-DD"));

                    },
                    eventClick: function (data, event, view) {
                        if(data.className[0] !== "holiday") {
                            _this.$router.push('/event/' + data.className + "/" + data.realID);
                        }
                    },
                    eventDrop: function(event, delta, revertFunc) {
                        if(event.className[0] !== "holiday") {
                            _this.$store.dispatch('changeCalendarEventDate',
                                                  {id: event.id, date: event.start})
                                .catch(err => {
                                    //err
                                    revertFunc();
                                })
                        } else {
                            revertFunc();
                        }
                    },

                    editable: true
                };
            },
            getEventTypes(){
                return "<div class='keysButtonWrapper'><ul><li class='wedding'>"+this.$t('eventType_wedding')+"</li><li class='barMitzvah'>"+this.$t('eventType_barMitzvah')+"</li><li class='circumcision'>"+this.$t('eventType_circumcision')+"</li><li class='bussines'>"+this.$t('eventType_bussines')+"</li><li class='other'>"+this.$t('eventType_other')+"</li><li class='holiday'>"+this.$t('eventType_holiday')+"</li><li class='meeting'>"+this.$t('eventType_meeting')+"</li><li class='quotation'>"+this.$t('eventType_quotation')+"</li></ul></div>";
            },
            getEvents(){
                let _this = this;
                return this.events.filter((item)=>{
                    if(_this.input != ''){
                        if((item.hasOwnProperty("title") && item.title.toString().toLowerCase().includes(_this.input)) || (item.hasOwnProperty("description") && item.description.toString().toLowerCase().includes(_this.input))) return true;
                        return false;
                    }else {
                        if (_this.hall != '' && item.hallID != _this.hall && item.className != 'meeting' && item.className != 'quotation') return false;
                        if (_this.eventType === 'holiday' && item.className === 'holiday') return true;
                        if (_this.eventType != '' && item.eventTypeID != _this.eventType) return false;
                    }

                    return true;
                });
            }
        }
    }
</script>

<style>

    .calendarView .innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .calendarView .editEventActions{
        float:left;
        margin-top: 6px;
    }
    .calendarView .editEventActions .backBtn span{
        color:#7c97c5;
        font-weight:700;
        font-size:1.235rem;
        display:inline-block;
        vertical-align:middle;
    }
    .calendarView .editEventActions .backBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:26px;
        height:18px;
        fill:#293b5a;
        margin-right:5px;
    }

    .calendarView .fc-toolbar.fc-header-toolbar{
        padding:30px;
        margin: 0;
    }
    .calendarView .fc-header-toolbar .fc-right .fc-button{
        color:#a5a5a5;
        font-size:0.8235rem;
        border-radius: 13px;
        width:70px;
        height:26px;
        border:1px solid #a5a5a5;
        background: none!important;
        box-shadow: none!important;
        float: right;
        line-height: 24px;
        z-index: 0!important;
    }
    .calendarView .fc-header-toolbar .fc-right .fc-button.fc-state-active{
        background: #293b5a!important;
        border-color:#293b5a;
        color:#fff;
    }
    .calendarView .fc-header-toolbar .fc-right .fc-button + .fc-button{
        margin-right:7px;
    }
    .calendarView .fc-rtl .fc-basic-view .fc-day-top .fc-day-number{
        float: right;
    }
    .calendarView .fc-view, .fc-view>table{
        z-index: 0;
    }
    .calendarView .fc-unthemed td.fc-today{
        background: none;
    }
    .calendarView .fc-day-header{
        color:#7791be;
        font-weight: bold;
        font-size: 1.059rem;
    }
    .calendarView .fc-header-toolbar .fc-center h2{
        float: right;
        color:#293b5a;
        font-weight: bold;
        font-size: 1.529rem;
    }
    .calendarView .fc-header-toolbar .fc-center .fc-button{
        float: right;
        background: none;
        border: none;
        box-shadow: none;
    }
    .calendarView .fc-icon, .fc-toolbar .fc-center{
        margin-right:-10em;
        margin-top: -0.5em;
    }
    .calendarView .fc-icon-left-single-arrow:after,
    .calendarView .fc-icon-right-single-arrow:after{
        font-weight: normal;
        font-size: 170%;
        color:#7893c1;
    }
    .calendarView .fc-header-toolbar .fc-left .fc-button{
        color: #293b5a;
        font-size: 0.8235rem;
        border-radius: 13px;
        width: 70px;
        height: 26px;
        border: 1px solid #293b5a;
        background: none!important;
        box-shadow: none!important;
        float: right;
        line-height: 24px;
    }

    .calendarView .fc-event{
        background: #f2f2f2;
        border-radius: 10px;
        color:#777777;
        font-size: 0.7647rem;
        border:0;
        padding: 2px 20px 2px 4px;
        margin: 0px 10px 0;
    }
    .calendarView .fc-event, .fc-event:hover{
        color:#777777;
    }
    .calendarView .fc-event:before{
        content: "";
        width:11px;
        height:11px;
        border-radius: 50%;
        position: absolute;
        top: 4px;
        right: 5px;

    }

    .calendarView .fc-day-grid-event .fc-content{
        white-space: normal;
    }
    .calendarView .fc-day-header{
        padding: 20px!important;
    }
    td.fc-widget-header{
        border-top:0!important;
        border-right:0!important;
        border-left: 0!important;
    }
    .calendarView .fc-body>tr>.fc-widget-content{
        border-right:0!important;
        border-left: 0!important;
        border-bottom: 0!important;
    }
    .calendarView .fc-day-number{
        color:#505050;
        font-weight: 400;
        font-size: 1.059rem;
        margin: 10px;
        padding: 5px!important;
        border-radius: 50%;
        line-height: 1.2rem;
    }
    .calendarView .fc-day-number:hover{
        text-decoration: none!important;
        color:#505050;
    }
    .calendarView .fc-today .fc-day-number{
        background: #7892c0;
        color:#fff;
    }
    .calendarView .fc-day:hover{
        background: rgba(119,145,190,0.3)!important;
        cursor: pointer;
    }
    .calendarView .fc-left{
        position: relative;
    }
    .calendarView .keysButtonWrapper{
        position: absolute;
        top: 50px;
        left: 0;
        margin: 0;
        width: 165px;
        border: 1px solid #dddddd;
        background: #fff;
        margin-left:0!important;
        z-index: 1;
        padding: 10px 5px;
        display: none;
    }
    .calendarView .fc-left.open .keysButtonWrapper{
        display: block;
    }
    .calendarView .keysButtonWrapper:before {
        content: "";
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-bottom: 12px solid #dddddd;
        position: absolute;
        bottom: 100%;
        left: calc(17% - 6px);
    }
    .calendarView .keysButtonWrapper:after {
        content: "";
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #fff;
        position: absolute;
        bottom: 100%;
        left: calc(17% - 4px);
    }
    .calendarView .keysButtonWrapper ul li{
        color: #a5a5a5;
        text-align: right;
        font-size: 0.8235rem;
        padding: 5px;
        padding-right: 30px;
        position: relative;
    }
    .calendarView .keysButtonWrapper ul li:before{
        content: "";
        width: 11px;
        height: 11px;
        border-radius: 50%;
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .calendarView .fc-event.wedding:before,
    .calendarView .keysButtonWrapper ul li.wedding:before{
        background: #f29af7;
    }
    .calendarView .fc-event.barMitzvah:before,
    .calendarView .keysButtonWrapper ul li.barMitzvah:before{
        background: #9a53f1;
    }
    .calendarView .fc-event.circumcision:before,
    .calendarView .keysButtonWrapper ul li.circumcision:before{
        background: #ccedfc;
    }
    .calendarView .fc-event.bussines:before,
    .calendarView .keysButtonWrapper ul li.bussines:before{
        background: #475c7f;
    }
    .calendarView .fc-event.other:before,
    .calendarView .keysButtonWrapper ul li.other:before{
        background: #f8bf46;
    }
    .calendarView .fc-event.holiday:before,
    .calendarView .keysButtonWrapper ul li.holiday:before{
        background: #f80010;
    }
    .calendarView .fc-event.meeting:before,
    .calendarView .keysButtonWrapper ul li.meeting:before{
        background: #f88872;
    }
    .calendarView .fc-event.quotation:before,
    .calendarView .keysButtonWrapper ul li.quotation:before{
        background: #37f8be;
    }
    a.fc-more{
        color: #293b5a;
        font-size: 0.7059rem!important;
        float: left;
        margin-top: 5px!important;
    }
    .calendarView .tooltiptopicevent{

        width: 260px;
        position: absolute;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.09);
        background: #fff;
        transform: translate(-58%,26px);
    }
    .calendarView .tooltipHeader{
        background: #f2f2f2;
        border-bottom:1px solid #b1e2f9;
        text-align: left;
        padding: 10px;
    }
    .calendarView .tooltipHeader:before{
        content: "";
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-bottom: 12px solid #f2f2f2;
        position: absolute;
        bottom: 100%;
        right: calc(50% - 6px);
    }
    .calendarView .tooltipHeader .closeBtn button{
        display:inline-block;
        vertical-align: middle;
    }
    .calendarView .tooltipHeader .closeBtn svg{
        width:15px;
        height:15px;
        fill:#969696;
    }
    .calendarView .tooltipHeader .editEventBtn svg{
        width:14px;
        height:15px;
        fill:#293b5a;
    }
    .calendarView .tooltipHeader .deleteEventBtn svg{
        width:13px;
        height:17px;
        fill:#969696;
    }
    .calendarView .tooltipTitle{
        text-align: right;
    }
    .calendarView .tooltipTitle span{
        color:#7994c2;
        font-weight: bold;
        font-size:0.8824rem;
    }
    .calendarView .tooltipTitle span + span{
        color:#293b5a;
        font-weight: bold;
        font-size:0.8824rem;
        font-style: italic;
    }
    .calendarView .tooltipContent ul{
        padding: 7px 0;
    }
    .calendarView .tooltipContent ul li {
        padding: 2px 15px;
    }
    .calendarView .tooltipContent ul li svg{
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        width:16px;
        height:16px;
        fill:#848484;
    }

    .calendarView .tooltipContent ul li span{
        display: inline-block;
        vertical-align: middle;
        color:#848484;
        font-size: 0.7647rem;
    }
    .calendarView .addEvent{
        width: 181px;
        height: 42px;
        border: 1px solid #52dbcd;
        border-radius: 21px;
        background: -moz-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41, 59, 90, 1)), color-stop(100%, rgba(123, 150, 196, 1)));
        /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ie10+ */
        background: linear-gradient(90deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* w3c */
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4', GradientType=1 );
        /* ie6-9 */
    }
    .calendarView .addEvent svg{
        display: inline-block;
        vertical-align: middle;
        width: 15px;
        height: 15px;
        fill: #fff;
        margin-left: 10px;
    }
    .calendarView .addEvent span{
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
        font-size: 0.8235rem;
        font-weight: 700;
        color:#fff;
    }
    .calendarView .innerBox.filterBox{
        margin-bottom:20px;
        padding:23px;
    }

    .calendarView .innerBox.filterBox h3{
        display: inline-block;
        vertical-align: middle;
    }
    .calendarView .innerBox.filterBox h3 span{
        color:#293b5a;
        font-size: 1rem;
        display: block;
        font-weight: 700;
        margin-top:10px;
    }
    .calendarView .innerBox.filterBox h3 svg{
        width:24px;
        height:24px;
        display: block;
        margin:0 auto;
        fill:#293b5a;
    }
    .calendarView .innerBox.filterBox .inputWrap{
        display: inline-block;
        vertical-align: middle;
        margin-right:15px;
        width:250px;
    }
    .calendarView .innerBox.filterBox  .inputWrap + .inputWrap{
        margin-top:0;

    }
    .calendarView .innerBox.filterBox .inputWrap label{
        color:#293b5a;
        font-size: 0.8824rem;
        font-weight: bold;
    }
    .calendarView .innerBox.filterBox .inputWrap input,
    .calendarView .innerBox.filterBox .inputWrap select{
        background:#fff;
        color:#434343;
    }
    .calendarView .innerBox.filterBox .inputWrap select#eventStatus{
        background: #f6f6f6
    }
    .calendarView .innerBox.filterBox .inputWrap.searchWrapper{
        width:335px;
    }
    .calendarView .innerBox.filterBox .inputWrap.searchWrapper input{
        padding-left: 40px;
    }
    .calendarView .innerBox.filterBox .inputWrap.searchWrapper .searchEvent{
        position: absolute;
        top: calc(50% - 10px);
        left: 20px;
    }
    .calendarView .innerBox.filterBox .inputWrap.searchWrapper .searchEvent svg{
        fill: #293b5a;
        width: 18px;
        height: 20px;
        display: block;
    }
    .calendarView .orDivider{
        display: inline-block;
        height: 54px;
        width: 54px;
        line-height: 54px;
        text-align: center;
        border-radius: 50%;
        background: #e0e0e0;
        color: #414141;
        font-size: 1rem;
        font-style: italic;
        margin: 0px 15px;
        vertical-align: bottom;
    }
    .calendarView .searchWrapper input[type="search"]{
        width:100%;
        height:unset;
        padding-bottom:unset;
    }
    .calendarView .searchWrapper{
        margin-top: 25px;
    }
</style>
